import React from 'react';
import { PhoneCountryCode, PhoneFlag, PhoneInput, PhoneInputWrapper, PhoneLabel, PhoneWrapper } from './Phone.style';

export interface Props {
  placeholderText?: string;
  labelHtml: string;
  name: string;
  disabled?: boolean;
}

export const Phone: React.FunctionComponent<Props> = ({
  placeholderText,
  labelHtml,
} : Props) => {
	
  return (
    <PhoneWrapper>
      <PhoneLabel htmlFor="phone">{ labelHtml }</PhoneLabel>
      <PhoneInputWrapper>
        <PhoneCountryCode>+33</PhoneCountryCode>
        <PhoneInput id="phone" type='tel' value={placeholderText} disabled/>
        <PhoneFlag />
      </PhoneInputWrapper>
    </PhoneWrapper>
	
  );
};